import { Button } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import GVCheckbox from 'components/lib/GVCheckbox/GVCheckbox';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import GVTooltip from 'components/lib/GVToolTip/GVTooltip';
import SparkleIcon from 'components/icons/SparkleIcon/SparkleIcon';
import { useState } from 'react';
import styles from './TextSetting.module.scss';

interface TextSettingProps {
  label: string;
  checked: boolean;
  onChange: () => void;
  tooltipText: string;
  disabledTooltipText?: string;
  preview?: {
    show: boolean;
    onClick: () => void;
  };
  className?: string;
  disabled?: boolean;
  showAiIcon?: boolean;
  'data-testid'?: string;
}

const useStyles = makeStyles()(() => ({
  checkboxLayout: {
    '&>.MuiFormControl-root > .MuiFormControlLabel-root': {
      marginRight: 0,
    },
    '&>.MuiFormControl-root > .MuiFormControlLabel-root > .MuiTypography-root': {
      whiteSpace: 'nowrap',
      fontWeight: 600,
      fontSize: '11px',
    },
  },
}));

export const TextSetting = ({
  label,
  checked,
  onChange,
  disabled,
  tooltipText,
  disabledTooltipText,
  preview,
  className,
  showAiIcon,
  'data-testid': testId,
}: TextSettingProps) => {
  const { classes, cx } = useStyles();
  const [tooltipContainer, setTooltipContainer] = useState<HTMLDivElement | null>(null);
  return (
    <div className={styles.root} data-testid={testId} ref={setTooltipContainer}>
      <div className={cx(classes.checkboxLayout, className)}>
        <GVCheckbox label={label} checked={checked} disabled={disabled} onChange={onChange} />
      </div>
      {showAiIcon && <SparkleIcon opacity={1} className={styles.ai} />}
      <GVTooltip
        title={disabled && disabledTooltipText ? disabledTooltipText : tooltipText}
        side="top"
        container={tooltipContainer}
        className={styles.tooltip}
      >
        <InfoOutlinedIcon className={styles.icon} />
      </GVTooltip>
      {preview?.show && (
        <Button className={styles.preview} variant="text" onClick={preview.onClick}>
          Preview
        </Button>
      )}
    </div>
  );
};
